import React from 'react';

class Services extends React.Component {
    render() {
        return (
            <div class="bg-stone-900 min-h-screen pt-16 md:pt-28 px-5 md:px-0 md:-mt-32" id="services">
                <div class="container text-center md:text-left text-white p-5 mx-auto md:mt-32">
                    <p class="text-5xl font-extrabold">SERVICES</p>
                    <p class="mb-12 italic">If the service you need is not listed down below, you can inquire <a href="https://twitter.com/messages/compose?recipient_id=1311990073982808066" target="_blank" rel="noreferrer" class="underline decoration-sky-500 decoration-2 underline-offset-4">here</a>.</p>
                    <div class="grid grid-row-1 md:grid-cols-4 gap-4">
                        <div>
                            <table class="border-separate border-spacing-2 w-full border border-slate-400 border-slate-500 bg-white text-sm shadow-sm bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500">
                                <thead class="bg-black">
                                    <tr>
                                        <th class="w-1/2 border border-slate-600 font-extrabold text-center p-4 text-white">FRONTEND</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td class="border border-slate-700 p-4 text-white font-extrabold bg-slate-700">HTML</td>
                                    </tr>
                                    <tr>
                                        <td class="border border-slate-700 p-4 text-white font-extrabold bg-slate-700">PLAIN CSS</td>
                                    </tr>
                                    <tr>
                                        <td class="border border-slate-700 p-4 text-white font-extrabold bg-slate-700">SASS</td>
                                    </tr>
                                    <tr>
                                        <td class="border border-slate-700 p-4 text-white font-extrabold bg-slate-700">BOOTSTRAP</td>
                                    </tr>
                                    <tr>
                                        <td class="border border-slate-700 p-4 text-white font-extrabold bg-slate-700">TAILWIND CSS</td>
                                    </tr>
                                    <tr>
                                        <td class="border border-slate-700 p-4 text-white font-extrabold bg-slate-700">VANILLA JAVASCRIPT, JQUERY</td>
                                    </tr>
                                    <tr>
                                        <td class="border border-slate-700 p-4 text-white font-extrabold bg-slate-700">REACTJS</td>
                                    </tr>
                                    <tr>
                                        <td class="border border-slate-700 p-4 text-white font-extrabold bg-slate-700">NEXT.JS</td>
                                    </tr>
                                    <tr>
                                        <td class="border border-slate-700 p-4 text-white font-extrabold bg-slate-700">TYPESCRIPT</td>
                                    </tr>
                                    <tr>
                                        <td class="border border-slate-700 p-4 text-white font-extrabold bg-slate-700">VUE.JS</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div>
                            <table class="border-separate border-spacing-2 w-full border border-slate-400 border-slate-500 bg-white text-sm shadow-sm bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500">
                                <thead class="bg-black">
                                    <tr>
                                        <th class="w-1/2 border border-slate-600 font-extrabold text-center p-4 text-white">BACKEND</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td class="border border-slate-700 p-4 text-white font-extrabold bg-slate-700">PHP</td>
                                    </tr>
                                    <tr>
                                        <td class="border border-slate-700 p-4 text-white font-extrabold bg-slate-700">LARAVEL (PHP FRAMEWORK)</td>
                                    </tr>
                                    <tr>
                                        <td class="border border-slate-700 p-4 text-white font-extrabold bg-slate-700">TYPESCRIPT</td>
                                    </tr>
                                    <tr>
                                        <td class="border border-slate-700 p-4 text-white font-extrabold bg-slate-700">JAVA (NO GUI)</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div>
                            <table class="border-separate border-spacing-2 w-full border border-slate-400 border-slate-500 bg-white text-sm shadow-sm bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500">
                                <thead class="bg-black">
                                    <tr>
                                        <th class="w-1/2 border border-slate-600 font-extrabold text-center p-4 text-white">DATABASE</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td class="border border-slate-700 p-4 text-white font-extrabold bg-slate-700">MYSQL</td>
                                    </tr>
                                    <tr>
                                        <td class="border border-slate-700 p-4 text-white font-extrabold bg-slate-700">MSSQL</td>
                                    </tr>
                                    <tr>
                                        <td class="border border-slate-700 p-4 text-white font-extrabold bg-slate-700">POSTGRESQL</td>
                                    </tr>
                                    <tr>
                                        <td class="border border-slate-700 p-4 text-white font-extrabold bg-slate-700">MARIADB</td>
                                    </tr>
                                    <tr>
                                        <td class="border border-slate-700 p-4 text-white font-extrabold bg-slate-700">MONGODB</td>
                                    </tr>
                                    <tr>
                                        <td class="border border-slate-700 p-4 text-white font-extrabold bg-slate-700">REDIS</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div>
                            <table class="border-separate border-spacing-2 w-full border border-slate-400 border-slate-500 bg-white text-sm shadow-sm bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500">
                                <thead class="bg-black">
                                    <tr>
                                        <th class="w-1/2 border border-slate-600 font-extrabold text-center p-4 text-white">OTHERS</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td class="border border-slate-700 p-4 text-white font-extrabold bg-slate-700">WEB HOSTING</td>
                                    </tr>
                                    <tr>
                                        <td class="border border-slate-700 p-4 text-white font-extrabold bg-slate-700">WORDPRESS</td>
                                    </tr>
                                    <tr>
                                        <td class="border border-slate-700 p-4 text-white font-extrabold bg-slate-700">GOOGLE SITES</td>
                                    </tr>
                                    <tr>
                                        <td class="border border-slate-700 p-4 text-white font-extrabold bg-slate-700">WIX</td>
                                    </tr>
                                    <tr>
                                        <td class="border border-slate-700 p-4 text-white font-extrabold bg-slate-700">FLOWCHART</td>
                                    </tr>
                                    <tr>
                                        <td class="border border-slate-700 p-4 text-white font-extrabold bg-slate-700">UML DIAGRAMS</td>
                                    </tr>
                                    <tr>
                                        <td class="border border-slate-700 p-4 text-white font-extrabold bg-slate-700">PSEUDOCODE</td>
                                    </tr>
                                    <tr>
                                        <td class="border border-slate-700 p-4 text-white font-extrabold bg-slate-700">DOCUMENTATION</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div >
        );
    }
}

export default Services;